const GA4_MEASUREMENT_ID_PATTERN = /^G-[A-Z0-9]+$/;

export const normalizeGa4MeasurementId = (
	value: string | null | undefined,
): string | undefined => {
	const normalizedValue = value?.trim();
	return normalizedValue === "" ? undefined : normalizedValue;
};

export const isValidGa4MeasurementId = (value: string): boolean =>
	GA4_MEASUREMENT_ID_PATTERN.test(value);
